/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

const styles = () => ({
  paper: {
    position: 'absolute',
    width: '100%',
    backgroundColor: '#fff',
    padding: '15px',
    borderRadius: '0px',
    fontSize: '14px',
  },
  modal: {
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '90%',
    maxWidth: '400px',
    maxHeight: '90vh',
    overflow: 'auto',
    '&::-webkit-scrollbar-track': {
      background: '#F8F8F8',
      borderRadius: '0px',
    },
    '&::-webkit-scrollbar': {
      width: '11px',
      background: '#F8F8F8',
      borderRadius: '0px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#CED1D6',
      borderRadius: '0px',
    },
  },

  '@media (min-width:375px)': {
    paper: {
      padding: '22px',
    },
  },
  '@media (min-width:768px)': {
    paper: {
      width: '50%',
      padding: '24px',
      fontSize: '18px',
    },
    modal: {
      width: '100%',
    },
  },
});

export default styles;
